// src/components/onboarding/OnboardingCompletionCard.js
import React from "react";
import { PartyPopper } from "lucide-react";

const OnboardingCompletionCard = ({ onAck }) => (
  <div className="flex flex-col items-center justify-center text-center px-4 min-h-[70vh]">
    <div className="w-16 h-16 bg-emerald-50 dark:bg-emerald-500/10 rounded-full flex items-center justify-center mb-5">
      <PartyPopper className="h-8 w-8 text-emerald-500" />
    </div>
    <h2 className="text-xl font-semibold text-foreground mb-2">You're all set!</h2>
    <p className="text-sm text-muted-foreground max-w-sm mb-6">
      Your agent is under test. From here you can run more batches, monitor production
      calls, and track quality over time.
    </p>
    <button
      onClick={onAck}
      className="px-5 py-2.5 bg-primary text-primary-foreground text-sm font-medium rounded-lg hover:bg-primary/90 transition-colors"
    >
      Go to dashboard
    </button>
  </div>
);

export default OnboardingCompletionCard;
